import { DefaultState } from "@core/redux/model/default/default.state.model";
import { ReduxAction } from "@core/redux/redux.module";
import {
  ACTIVATE_RECEIVE,
  ACTIVATE_REQUEST,
  CHANGE_STATE,
  CONFIRM_LOGIN_RECEIVE,
  CONFIRM_LOGIN_REQUEST,
  GET_STATUS_RECEIVE,
  GET_STATUS_REQUEST,
  LOGIN_RECEIVE,
  LOGIN_REQUEST,
  LOGOUT_RECEIVE,
  LOGOUT_REQUEST,
  MODIFY_STATIC_PASSWORD_RECEIVE,
  MODIFY_STATIC_PASSWORD_REQUEST,
  RESEND_CONFIRMIATION_CODE_RECEIVE,
  RESEND_CONFIRMIATION_CODE_REQUEST,
  RESET_DEFAULT_STATE
} from "@core/redux/action/default/default.action.factory";

export const DEFAULT_STATE_NAME = "default";

export function defaultReducer (state: DefaultState, action: ReduxAction<any>): DefaultState {
  if (!state) {
    state = getEmptyDefaultState();
  }

  switch (action.type) {
    case CHANGE_STATE:
      return changeState(state, action.payload);
    case LOGIN_RECEIVE:
      return changeState(state, action.payload);
    case GET_STATUS_RECEIVE:
      return changeState(state, action.payload);
    case LOGOUT_RECEIVE:
      return changeState(state, getEmptyDefaultState());
    case RESET_DEFAULT_STATE:
      return changeState(state, getEmptyDefaultState());
    case LOGIN_REQUEST:
    case CONFIRM_LOGIN_REQUEST:
    case CONFIRM_LOGIN_RECEIVE:
    case LOGOUT_REQUEST:
    case MODIFY_STATIC_PASSWORD_REQUEST:
    case MODIFY_STATIC_PASSWORD_RECEIVE:
    case RESEND_CONFIRMIATION_CODE_REQUEST:
    case RESEND_CONFIRMIATION_CODE_RECEIVE:
    case GET_STATUS_REQUEST:
    case ACTIVATE_REQUEST:
    case ACTIVATE_RECEIVE:
    default:
      return state;
  }

  function changeState(originalState: DefaultState, changes: Object): DefaultState {
    return Object.assign({}, originalState, changes);
  }

  function getEmptyDefaultState(): DefaultState {
    return {
      staticPassword: null,
      status: null,
      cardLastNumber: null,
      ownerName: null,
      cardPhoneNumber: null
    };
  }
}
